<template>
  <div class="saveinvoicemodelbox">
    <div v-if="!isSuccess">
      <h3 class="mb-3">发票 - 个人信息</h3>
      <hr class="mb-5">
      <div class="form-group">
        <label>个人姓名</label>
        <input type="text" v-model="person" class="form-control form-control-lg">
      </div>
      <button type="submit" class="btn btn-primary btn-lg btn-round" @click="loginFun">
        <i v-if="isLoading" class='iconfont icon-jiazai xuanzhuan'></i>
        确认修改
      </button>
    </div>
    <div class="isSuccessBox" v-else>
      <i class="iconfont icon-chenggong text-success"></i>
      <span>修改成功</span>
    </div>
  </div>
</template>

<script>
import generalMix from '@/util/mix/general';
import resultCommons from '@/util/resultcommons';
import { EventBus } from '@/util/eventBus';
import commons from '@/util/commons';
import * as types from '@/store/types';

export default {
  name: 'saveinvoicemodelbox',
  props:['parameter'],
  mixins: [generalMix],
  data () {
    return {
      person:'',
      isSuccess: false,
      isLoading: false
    }
  },
  methods:{
    // 登录
    loginFun() {
      EventBus.$emit('globalLoadingFun', {bool:true,loading:false});
      this.isLoading = true;
      // 更新本地缓存
      const localOb = this.localUser;
      localOb.invoiceInfo.person = this.person;
      // 可以执行登录
      resultCommons.apiSaveinvoiceinfo(this, { type:2,token: this.localUser.token, ...localOb.invoiceInfo }).then(app=>{
        if(app.state === 200){
          commons.saveTodos('localUser', localOb);
          // 更新本地路由的登录信息
          this.$store.commit(types.SAVE_LOCALUSER, { bool: true });
          // 执行其他操作
          this.$message.showMsgBox({ type: 'success', content: app.message });
          EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
          this.isLoading = false;
          // 切换为修改成功页面
          this.isSuccess = true;
        }else{
          EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
          this.isLoading = false;
          this.$message.showMsgBox({ type: 'warning', content: app.message });
        }
      });
    }
  },
  created() {
    this.person = this.localUser.invoiceInfo.person;
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>

.saveinvoicemodelbox {
  padding: 30px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  background: #FFFFFF;
  color: #000000;
  width: 480px;
  height: 100%;
  padding-bottom: 0;
  border-radius: 1rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  overflow-y: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
}
div.isSuccessBox{
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  i{
    font-size: 56px;
  }
  span{
    margin-top: 50px;
    font-size: 16px;
  }
}
@media (max-width: 767px) {
  .saveinvoicemodelbox {
    width: 80vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/user/Saveinvoiceperson.vue